export const mid = import.meta.env.VITE_LOCALDEV_MID;

export const fuel2token = import.meta.env.VITE_LOCALDEV_FUEL_TOKEN;

export const fuelapiRestHost = import.meta.env.VITE_LOCALDEV_FUELAPI_REST_HOST;

export const mode = import.meta.env.VITE_NODE_ENV;

export const mcApiUrl = import.meta.env.VITE_MC_API_CLIENT_URL;

export const coreApiUrl = import.meta.env.VITE_CORE_API_CLIENT_URL;

export const domain = import.meta.env.VITE_DOMAIN;

export const agentVersion = import.meta.env.VITE_AGENT_VERSION;

export const messageActivityName = import.meta.env.VITE_CUSTOMACTIVITY_NAME;

export const executeUrl = import.meta.env.VITE_EXECUTE_PATH;

export const publishPath = import.meta.env.VITE_PUBLISH_PATH;

export const validatePath = import.meta.env.VITE_VALIDATE_PATH;

export const isDevServer = import.meta.env.VITE_IS_DEV_SERVER;

export const partnerUrl = import.meta.env.VITE_PARTNER_URL;

export const datadogApplicationId = import.meta.env.VITE_DATADOG_APPLICATION_ID || '';

export const datadogClientToken = import.meta.env.VITE_DATADOG_CLIENT_TOKEN || '';

export const datadogService = import.meta.env.VITE_DATADOG_SERVICE || '';

export const staticUrl = import.meta.env.VITE_STATIC_URL || '';
